<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  props: ["data", "options"],
  watch: {
    data() {
      this.renderData();
    },
  },
  mounted() {
    this.renderData();
  },
  methods: {
    renderData() {
      this.renderChart(this.data, {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false,
        },
        ...this.options,
      });
    },
  },
};
</script>
